import AdminLayout from '../components/AdminLayout';
import AuditLogExplorer from '../../components/audit/AuditLogExplorer';

// The platform console's view: every organization's trail in one list.
//
// The screen itself lives in components/audit/AuditLogExplorer.jsx, shared with
// the firm cockpit's `/org-admin/audit-logs`. One component with two hosts, not
// two copies — an audit log that reads differently depending on where it was
// opened is worse than no audit log. `scope` decides what is FETCHED and SHOWN;
// what a caller may actually see is decided by the server in both services.

function AdminAuditLogs() {
  return (
    <AdminLayout
      title="Audit Logs"
      subtitle="Every high-value action across every organization — reveals, changes, and denials"
    >
      <AuditLogExplorer scope="platform" />
    </AdminLayout>
  );
}

export default AdminAuditLogs;
